module.exports = __webpack_public_path__ + "img/sankaku_80_red.7b59ed6f.png";